{
  "meta": {
    "title": "AmberBytes — Software vakmensen",
    "description": "AmberBytes bouwt snelle, betrouwbare en mensgerichte software voor ambitieuze teams."
  },
  "nav": {
    "services": "Diensten",
    "about": "Over ons",
    "tech": "Tech",
    "contact": "Contact"
  },
  "hero": {
    "headline": "We veranderen ruwe ideeën in gepolijste software.",
    "subheadline": "AmberBytes is een compact technisch consultancybureau dat digitale producten ontwerpt, bouwt en lanceert met helderheid en snelheid.",
    "cta": "Start een project"
  },
  "services": {
    "title": "Wat we doen",
    "subtitle": "End-to-end productexpertise, van eerste schets tot productieschaal.",
    "items": [
      {
        "title": "Productstrategie",
        "description": "We helpen je het signaal in de ruis te vinden en een product te definiëren waar je gebruikers van houden."
      },
      {
        "title": "Webapplicaties",
        "description": "Moderne, toegankelijke en snelle frontends gebouwd met React, TypeScript en Tailwind."
      },
      {
        "title": "Backendsystemen",
        "description": "Robuuste API's, cloudinfrastructuur en datapipelines die meeschalen met je bedrijf."
      },
      {
        "title": "Teamversterking",
        "description": "Senior engineers ingebed in je team om levering te versnellen en de lat hoger te leggen."
      }
    ]
  },
  "about": {
    "title": "Waarom AmberBytes?",
    "paragraphs": [
      "We geloven dat geweldige software ontstaat uit nieuwsgierigheid, discipline en nauwe samenwerking. Elk project begint met luisteren.",
      "Ons team heeft producten geleverd voor startups, scale-ups en enterprise-klanten in fintech, healthtech en digitale commerce.",
      "We geven om schone architectuur, snelle feedbackloops en design dat werkt voor echte mensen."
    ]
  },
  "tech": {
    "title": "Tools waar we van houden",
    "subtitle": "We kiezen de juiste stack voor de klus — dit pakken we het vaakst."
  },
  "contact": {
    "title": "Laten we iets amber bouwen.",
    "subtitle": "Vertel ons waar je aan werkt. We reageren binnen twee werkdagen.",
    "name": "Naam",
    "email": "E-mail",
    "message": "Bericht",
    "send": "Bericht versturen",
    "success": "Bedankt — we nemen snel contact op.",
    "emailLabel": "Of schrijf ons direct op"
  },
  "footer": {
    "rights": "© {year} AmberBytes. Alle rechten voorbehouden.",
    "language": "Taal"
  }
}
